import React from "react";

const VCard = () => {
  const handleDownloadVCard = () => {
    // Datos de la vCard
    const vCardData = `
BEGIN:VCARD
VERSION:2.1
FN:Nisì by Giuseppe
ORG:Nisì by Giuseppe
TEL;WORK;VOICE:+34 971 310 280
ADR;TYPE=WORK:;;Calle dels Pins 7;Alcúdia;Illes Balears;07400;Spain
URL:https://www.nisibygiuseppe.com/
END:VCARD
    `;

    // Crear un blob con los datos de la vCard
    const blob = new Blob([vCardData], { type: "text/vcard" });

    // Crear un enlace para descargar el archivo
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "nisi_by_giuseppe.vcf";

    // Añadir el enlace al DOM y hacer clic en él para iniciar la descarga
    document.body.appendChild(link);
    link.click();

    // Eliminar el enlace del DOM
    document.body.removeChild(link);
  };

  return (
    <button onClick={handleDownloadVCard} className="button-styles hover-text">
      <span className="tooltip-text" id="fade">vCard</span>
      <i className="bi bi-download"></i>
    </button>
  );
};

export default VCard;
